import { SET_GROUP_ALIASES } from '../actions/types';

export default function groupAliases(state = [], { type, payload }) {
	switch (type) {
		case SET_GROUP_ALIASES:
			return payload;
		default:
			return state;
	}
}
